export default "__VITE_ASSET__D89UxSx2__"